import { render, staticRenderFns } from "./RegisterOTP.vue?vue&type=template&id=699076f4&scoped=true&"
import script from "./RegisterOTP.vue?vue&type=script&lang=js&"
export * from "./RegisterOTP.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOTP.vue?vue&type=style&index=0&id=699076f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699076f4",
  null
  
)

export default component.exports